import { render } from "./airtime.vue?vue&type=template&id=cfa727c8&scoped=true"
import script from "./airtime.vue?vue&type=script&lang=js"
export * from "./airtime.vue?vue&type=script&lang=js"

import "./airtime.vue?vue&type=style&index=0&id=cfa727c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa727c8"]])

export default __exports__